import request from '../utils/https'

// 會員註冊
export function sendMessage (params) {
    return request({
        url: '/message/send',
        method: 'post',
        data:params
    })
}

// 會員登入
export function getExchangeMessageList (params) {
    return request({
        url: '/exchange/messageList',
        method: 'post',
        data:params
    })
}

// 會員登入
export function getTogetherMessageList (params) {
    return request({
        url: '/together/messageList',
        method: 'post',
        data:params
    })
}
// 會員登出
export function getMessageCount (params) {
    return request({
        url: '/message/count',
        method: 'post',
        data:params
    })
}